export const SET_SELECTED_SUBJECT = 'SET_SELECTED_SUBJECT';
export const SET_ALL_SUBJECTS = 'SET_ALL_SUBJECTS';
export const SET_SPARKY_ENABLED = 'SET_SPARKY_ENABLED';
